<template>
    <el-row class="addQuestion">
        <el-row>
            <el-card class="card">
                <el-row slot="header" class="clearfix">
                    <el-page-header @back="goBack" :content="titleName=='归档问题'?'归档问题':'添加问题'"></el-page-header>
                </el-row>
                <el-row>
                    <el-row class="formC" type="flex">
                        <el-col >
                            <el-form :model="questForm" ref="questForm" label-position="right" size="small">
                                <el-form-item label="问题题目：" label-width="100px" prop="title">
                                    <el-input v-model="questForm.title"></el-input>
                                </el-form-item>
                                <el-form-item label="工单类型：" label-width="100px" prop="type">
                                    <el-select v-model="questForm.type">
                                      <el-option v-for="item in datatype" :label="item.text" :value="item.value" :key="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="型号：" label-width="100px" prop="goods_model">
                                    <el-input v-model="questForm.goods_model"></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="摘要：" label-width="100px" prop="description">
                                    <el-input type="textarea" v-model="questForm.description"></el-input>
                                </el-form-item> -->
                                <el-form-item class="editor"  label="详解：" label-width="100px" prop="detail">
                                    <quill-editor ref="myQuillEditor" v-model="questForm.detail" :options="editorOption"></quill-editor>
                                </el-form-item>
                                <el-form-item class="fileList" label="文件：" label-width="100px">
                                    <div class="fileListContent">
                                        <div class="items" v-for="(item,index) in  file_list" :key="item.id">
                                            <div class="imgs">
                                              <img v-if="item.url.split('.')[1] == 'txt'" src="../assets/filetype/txt.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'pdf'" src="../assets/filetype/pdf.png"  alt="">
                                              <img v-if="item.url.split('.')[1] == 'ppt' || item.url.split('.')[1] == 'pptx'" src="../assets/filetype/ppt.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'xls' || item.url.split('.')[1] == 'xlsx'" src="../assets/filetype/excel.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'doc' || item.url.split('.')[1] == 'docx'" src="../assets/filetype/word.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'mp4' || item.url.split('.')[1] == 'mov' || item.url.split('.')[1] == 'ogg' || item.url.split('.')[1] == 'webm'" src="../assets/filetype/video.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == 'avi'" src="../assets/filetype/avi.jpg" alt="">
                                              <img v-if="item.url.split('.')[1] == '7z' || item.url.split('.')[1] == 'rar'" src="../assets/filetype/zip.png" alt="">
                                              <i class="el-icon-close" @click="delateFile(item,index)"></i>
                                            </div>
                                            <div class="name">{{ item.name }}</div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item v-show="false"  prop="uploadImg" label="上传图片">
                                      <el-upload
                                        :action="action"
                                        header="Content-Type:application/x-www-form-urlencoded;charset=utf-8"
                                        list-type="picture-card"
                                        :auto-upload="true"
                                        :file-list="filsList"
                                        :limit="9"
                                        
                                        :before-upload="beforeAvatarUpload"
                                        :on-change="imgHandleChange"
                                        :on-success="imgSuccess"
                                        :on-remove="imgRemove"
                                        ref="pictureUpload"
                                        >
                                          <i slot="default" class="el-icon-plus"></i>
                                          <div slot="file" slot-scope="{file}">
                                            <img
                                              class="el-upload-list__item-thumbnail"
                                              :src="file.url" alt=""
                                            >
                                            <span class="el-upload-list__item-actions">
                                              <span
                                                class="el-upload-list__item-preview"
                                                @click="handlePictureCardPreview(file)"
                                              >
                                                <i class="el-icon-zoom-in"></i>
                                              </span>
                                              <span
                                                v-if="!disabled"
                                                class="el-upload-list__item-delete"
                                                @click="imgHandleRemove(file)"
                                              >
                                                <i class="el-icon-delete"></i>
                                              </span>
                                            </span>
                                          </div>
                                      </el-upload>
                                      <el-dialog :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                      </el-dialog>
                                </el-form-item>
                                <el-form-item   prop="uploadFile"    label="视频/文件">
                                      <el-upload
                                        ref="dmtUploadFile"
                                        class="upload-demo"
                                        :action="action"
                                        header="Content-Type:application/x-www-form-urlencoded;charset=utf-8"
                                        :auto-upload="true"
                                        :on-preview="fileHandlePreview"
                                        :on-remove="fileHandleRemove"
                                        multiple
                                        :limit="3"
                                        :before-upload="beforeFileUpload"
                                        :on-exceed="fileHandleExceed"
                                        :on-change="fileHandleChange"
                                        :on-success="fileSuccess"
                                        accept="doc,docx,ppt,pptx,pdf,txt,xls,mp4,avi"
                                        :file-list="fileList2">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">只能上传doc,docx,ppt,pptx,pdf,txt,xls,mp4,avi文件，且不超过7M</div>
                                      </el-upload>
                                </el-form-item>
                                <el-form-item class="bytn">
                                   <el-button type="primary" :loading="isloading" @click="submitForm('ruleForm')">提交</el-button>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </el-row>
            </el-card>
        </el-row>
    </el-row>
</template>

<script>
import { getOrderType,addQs,departTable,getonFile,removeAttach } from '../utils/api'
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { log } from 'console';
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image"],
  ["clean"]
];
export default {
  components: { 
    quillEditor
   },
  props: {},
  data() {
    return {
      order_id:'',
      isloading:false,
      titleName:"",
      filsList:[],
      fileList2:[],
      imgList:[],
      dialogImageUrl:'',
      dialogVisible: false,
      disabled: false,
      // action:'https://dev.ebyte.com/open/api/v1/attach/uploader?user_token='+localStorage.getItem('user_token'),
      action:localStorage.getItem('uploadUrl')+localStorage.getItem('user_token'),
      questForm:{
          type:'',
          title:'',
          detail:'',
          goods_model:'',
          content:'',
          description:'',
          image:[],
          file:[],
          replies:[]
      },
      datatype:[],
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function(value) {
                if (value) {
                  document.querySelector("input[name='file']").click();
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          }
        }
      },
      file_list:[],
      realFileList:"",
      urlHerf:localStorage.getItem('urlHerf')
    };
  },
  watch: {},
  computed: {},
  methods: {
    goBack(){
        this.$router.go(-1)
    },
    //获取工单类型
    getOrType() {
      var that = this
      getOrderType()
        .then(res => {
          console.log(res, '工单类型');
          that.datatype = []
          res.data.forEach(item => {
            that.datatype.push({ text: item.type, value: item.type })
          })
        })
    },
    //提交工单
    submitForm(){
        var that = this
        that.isloading = true
        var str = ""
        that.file_list.forEach(val=>{
        str += val.url + ','
        })
        if(that.fileList2.length !== 0){
          that.fileList2.forEach(val=>{
            str += val + ','
          })
        }
        that.realFileList = str
        console.log(that.realFileList,'that.realFileList');
        var params = {
            order_id:that.order_id,
            type:that.questForm.type,
            goods_model:that.questForm.goods_model,
            title:that.questForm.title,
            detail:that.questForm.detail,
            description:that.questForm.description,
            file:that.realFileList,
            image:that.imgList.join(','),
        }
        addQs(params)
        .then(res=>{
            console.log(res,'添加工单');
            if(res.message.status == 'success'){
                that.$message.success(res.message.text)
                that.$refs['questForm'].resetFields();
                that.$refs.pictureUpload.uploadFiles = []
                that.fileList2 = []
                that.imgList = []
                that.$router.go(-1)
                that.isloading = false
            }else{
                that.$message.error(res.message.text)
                that.isloading = false
            }
        })
        .catch(err=>{
            that.$message.error(err)
            console.log(err,'err');
            that.isloading = false
        })
    },
    //获取顶级分类列表
    getCategoryTable(){
        departTable()
        .then(res=>{
            console.log(res,'顶级分类');
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },
    onEditorBlur(e){
      console.log(e,'onEditorBlur');
    },
    onEditorFocus(e){
      console.log(e,'onEditorFocus');
    },
    onEditorReady(e){
      console.log(e,'onEditorReady');
    },

    //图片上传
    //移除图片
    imgHandleRemove(file) {
      console.log(file);
      console.log('12123123');
      var that = this
      let uploadFiles = that.$refs.pictureUpload.uploadFiles
      for (var i = 0; i < uploadFiles.length; i++) {
        if (uploadFiles[i]['url'] == file.url) {
          uploadFiles.splice(i, 1)
        }
      }
      that.imgList.forEach((item,index)=>{
        if(item == file.response.data[0].url){
          that.imgList.splice(index,1)
        }
      })
    },
    //上传图片限制
    beforeAvatarUpload(file){
        const isLt5M = file.size / 1024 / 1024 < 5;

        if (!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!');
        }
        return  isLt5M;
    },
    imgRemove(file, fileList){
      console.log(file,'imgRemove');
      console.log(fileList,'fileListimgRemove');
    },
    //放大图片
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    // 图片状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    imgHandleChange(file){
        // console.log(file,'asdasasd');
    },
    //图片上传成功的钩子
    imgSuccess(res, file, fileList){
        console.log(res,'res上传图片成功的返回');
        var that = this
        if(res.message.status == 'success'){
          that.imgList.push(res.data[0].url)
          that.$message.success('上传成功')
        }else{
          that.$message.error('上传失败')
          that.$refs.pictureUpload.uploadFiles.splice(that.$refs.dmtUploadFile.uploadFiles.indexOf(res), 1);
        }
        let quill = that.$refs.myQuillEditor.quill
        let range = quill.getSelection()
        let length = range.index;
        quill.insertEmbed(length,'image',that.urlHerf+res.data[0].url)
        quill.setSelection(length + 1)
        console.log(that.questForm.image);
    },

    //文件上传
    fileHandlePreview(file){
      console.log(file);
    },
    //文件限制
    beforeFileUpload(file){
      const isLt7M = file.size / 1024 / 1024 < 7;
      // if(!isLt7M){
      //   this.$message.error('上传文件大小不能超过 7MB!')
      //   return isLt7M
      // }
    },
    fileHandleRemove(file, fileList){
      var that = this
      that.fileList2.forEach((item,index)=>{
        if(item == file.response.data[0].url){
          that.fileList2.splice(index,1)
        }
      })
    },
    fileBeforeRemove(file, fileList){
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    //超出文件限制
    fileHandleExceed(files, fileList){
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    fileHandleChange(file){
      console.log(file,'文件');
    },
    fileSuccess(res, file, fileList){
      var that = this
      if(res.message.status == 'success'){
          that.fileList2.push(res.data[0].url)
      }else{
        that.$message.error(res.message.text)
        console.log( that.fileList2,'that.fileList2');
        that.$refs.dmtUploadFile.uploadFiles.splice(that.$refs.dmtUploadFile.uploadFiles.indexOf(res), 1);
      }
    },
    getonFileList(){
      var that = this
      var params = {
        order_id:	that.order_id
      }
      getonFile(params)
      .then(res=>{
          if(res.message.status == 'success'){
            that.questForm.type = res.data.type;
            that.questForm.goods_model = res.data.goods_model;
            that.questForm.title = res.data.title;
            // that.questForm.detail = res.data.detail;
            that.questForm.description = res.data.description
            that.questForm.replies = res.data.replies
            var str = ''
            var firstData = {
            content : res.data.description,
            attach_file:res.data.attach_file,
            attach_image:res.data.attach_image,
            reply_person:res.data.close_person
            }
            that.questForm.replies.unshift(firstData)
            console.log( that.questForm.replies,' that.questForm.replies');
            var fileStr = ''
            var fileArr = []
            if(res.data.attach_file_info.length !== 0){
              fileArr = [...fileArr,...res.data.attach_file_info]
            }
            that.questForm.replies.forEach(item=>{
              var attachImgList = item.attach_image.length == 0?[]:item.attach_image.split(",")
              // todo
              // if(item.attach_file !== ''){
              //   fileStr += ','+item.attach_file
              // }
              if(item.attach_file_info && item.attach_file_info.length !== 0){
                console.log(item.attach_file_info,'item.attach_file_info');
                fileArr = [...fileArr,...item.attach_file_info]
              }
              //end
              
              // console.log(file_List,'file_List');
              //沟通记录
              str += `<div style="margin-top: 10px;border-bottom: 1px solid rgb(202, 202, 202);">`
                str += `<div style="color: #409eff;">${item.reply_person}</div>`
                  str += `<div style="width: 50%;background: rgb(221, 221, 221);color: #333333;font-size: 14px;padding: 10px;margin-top: 10px;"></div>`
                    str += `<div style="color:#333333;margin: 10px 0;">${item.content}</div>`
                    console.log(attachImgList.length,'attachImgList');
                      if(attachImgList.length !==0){
                         attachImgList.forEach(itemChildren=>{
                            itemChildren = that.urlHerf + itemChildren
                            str += `<div style="width: 100px;"><img style="width: 100px;height: 100px;" src="${itemChildren}" alt=""></div>`
                        })
                      }
                      str += `</div>`
            })
            var list = fileStr.split(',')
            var delIst = list.shift()
            // that.file_list = list
            that.file_list = fileArr
            console.log(that.file_list,'that.file_list');
            // console.log(list,'hihi')
            that.questForm.detail = str
          }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //删除附件
    delateFile(item,index){
      this.file_list.splice(index,1);
    }

  },
  created() {},
  mounted() {},
  activated(){
    console.log('这是PC端');
    this.$refs.questForm.resetFields();
    this.getOrType()
    this.getCategoryTable()
    console.log(this.$route.params,'this.$route.params');
    this.titleName = this.$route.params.name
    if(JSON.stringify(this.$route.params) !== '{}'){
      this.order_id  = this.$route.params.data
      this.getonFileList()
    }else{
      this.order_id  = ''
    }
  }
};
</script>
<style lang="scss" scoped>
.addQuestion{
    .bytn{
        text-align: center;
        button{
            width: 200px;
        }
    }

    .editor{
      height: 400px;
      .quill-editor{
          min-height: 300px;
          height: 300px;
      }
    }
}

.formC{
  .fileList{
    .fileListContent{
      display: flex;
      .items{
        margin-left: 10px;
        width: 60px;
        .imgs{
          position: relative;
          img{
            width: 100%;
          }
          i{
            position: absolute;
            top: 0;
            right: 0;
            font-size: 16px;
            background: #fff;
          }
          i:hover{
            color:red;
            cursor: pointer;
          }
        }
        .name{
          // width: 60px;
          font-size: 12px;
          line-height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }
  }
}
</style>